import React from 'react';
import { useExpenseAccountIdInputQuery } from '../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../dum';
import {
    EXPENSE_RESOURCES,
    IExpense,
    RESOURCE_ID,
    TRANSFER_RECEIPTS,
} from '../expense-form';
import { useFormContext, useWatch } from 'react-hook-form';
import { usePrefillFromSupplierAccount } from '../use-prefill-from-supplier-account';
import { EXPENSE_FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

const ID: keyof IExpense = 'id';

export function ExpenseAccountIdInput() {
    const inputName: keyof IExpense = 'account';
    const { data } = useExpenseAccountIdInputQuery();
    const rx = useFormContext();
    const { prefillFromAccount } = usePrefillFromSupplierAccount();

    // A payment is already applied to this supplier, so the supplier is
    // locked (the backend rejects the change too).
    const transferReceipts = useWatch({
        name: TRANSFER_RECEIPTS,
    }) as IExpense['transfer_receipts'];
    const hasTransfers = !!transferReceipts?.length;

    const accounts = data?.getAccounts || [];

    return (
        <RhSingleAutocomplete
            itemText={'compound_name'}
            itemValue={'id'}
            name={inputName}
            label={shortLabel(EXPENSE_FIELD_LABELS.account_id)}
            options={accounts}
            returnObject
            disabled={hasTransfers}
            helperText={
                hasTransfers
                    ? 'No se puede cambiar: el gasto tiene transferencias'
                    : undefined
            }
            onChange={(val) => {
                // Pre-fill payment date, supplement, and the receipt-aware
                // folio/tax requirements from the picked supplier account.
                prefillFromAccount(val as IExpense['account']);

                const expenseResources = rx.getValues(
                    EXPENSE_RESOURCES,
                ) as IExpense['expense_resources'];
                const isEditing = !!rx.getValues(ID);

                if (
                    !isEditing &&
                    expenseResources.length === 1 &&
                    val?.resource_id
                ) {
                    rx.setValue(
                        `${EXPENSE_RESOURCES}.0.${RESOURCE_ID}`,
                        val.resource_id,
                    );
                }
            }}
        />
    );
}
